enum enOrderState {
    Draft = 'Draft',
    SendingInProgress = 'SendingInProgress',
    SentToWMS = 'SentToWMS',
    SentToWMSAndTMS = 'SentToWMSAndTMS',
    InProgress = 'InProgress',
    Completed = 'Completed',
    CancelledByTMS  = 'None',
    Error = 'Error',
}

export default enOrderState;
